import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/tipos-de-incidencias-unidades';

/**
 * GET Tipos De Incidencias Unidades
 * @returns {Promise<object[]>}
 */
export const getTiposDeIncidenciasUnidades = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo De Incidencia Unidad
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDeIncidenciaUnidad = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo De Incidencia Unidad
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeIncidenciaUnidad = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo De Incidencia Unidad
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeIncidenciaUnidad = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo De Incidencia Unidad
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoDeIncidenciaUnidad = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
